var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcBtnShareV2 = function SvgIcBtnShareV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.921 7.078a.579.579 0 0 0 1.158 0V2.68l1.537 1.464a.579.579 0 0 0 .798-.839L6.9.91a.579.579 0 0 0-.798 0L3.586 3.305a.579.579 0 1 0 .798.839L5.921 2.68v4.398Zm-3.513.719a.579.579 0 1 0-1.158 0v2.874c0 .32.26.579.579.579h9.342c.32 0 .579-.26.579-.579V7.797a.579.579 0 0 0-1.158 0v2.295H2.408V7.797Z"
  })));
};
export default SvgIcBtnShareV2;